<template>
    <div class="white-wrapper">
        <main class="privacy">
            <div class="privacy__wrapper">
                <div class="privacy__big-title">
                    <span>AÇIK RIZA FORMU</span>
                </div>
                <div class="privacy__description">
                    <div class="col-12" style="text-align: center;">
                        
                        <p>Reckitt Benckiser Ev ve Hijyen Ürünleri Anonim Şirketi <b>(“RB”)</b> tarafından 6698 sayılı Kişisel Verilerin Korunması Kanunu’nun <b>(“KVKK”)</b> ilgili hükümlerine uygun olarak bilginize sunulan İnternet Sitesi Kişisel Verilerin Korunması Aydınlatma Metnini incelemiş ve anlamış olarak, </p>
                        <p>-	iletişim bilgileriniz ticari elektronik ileti gönderimine ilişkin ayrıca onayınız olması halinde sizlerle iletişim kurulabilmesi ve reklam, pazarlama ve promosyon faaliyetlerimizin yürütülebilmesi, ticari ve ticari olmayan her türlü amaçla iletişime geçilebilmesi amaçlarıyla, </p>
                        <p>toplanmakta, işlenmekte, elektronik olarak e-posta ortamında sınırlı süre ile sınırlı olarak saklanmakta, RB’nin bulut hizmet aldığı üçüncü kişi işbirliği ortaklarına, tedarikçilerine ve hizmet aldığı üçüncü kişilere işlenmek veya saklanmak üzere yasal düzenlemenin öngördüğü önlemler gözetilerek aktarılmakta, veri koruması ve güvenliği önlemlerine riayet olunarak ilgili üçüncü kişilerle gerekli olduğu ölçüde paylaşılmaktadır.</p>
                        <p>Ayrıca kişisel verileriniz;</p>
                        <p>-	yurt dışında bulunan RB Grup Şirketleri’ne:  depolama, arşivleme, bilişim teknolojileri (sunucu, hosting, program, bulut bilişim) ve çağrı merkezi gibi alanlarda destek alınan yurt dışında mukim üçüncü kişi işbirliği ortaklarımıza, pazarlama ve satış süreçlerinde hizmet alınan yurt dışındaki üçüncü kişilere, ilgili işleme amaçlarına yönelik hizmet alınan iş ortaklarına, tedarikçilere ve belirlenen amaçlarla aktarımın gerekli olduğu diğer ilişkili taraflar ile yetkili kurum ve kuruluşlara aktarılabilmektedir. </p>
                        <p>Yukarıda belirtilen hususlarda gerekli aydınlatma tarafıma yapılmış olup, ayrıca tarafımca İnternet Sitesi Kişisel Verilerin Korunması Aydınlatma Metni okunup anlaşılmıştır. Bu kapsamda, yukarıda işaretlemiş olduğum kişisel verilerimin yukarıda belirtilen amaçlar doğrultusunda işlenmesine 6698 sayılı KVKK uyarınca açık onay verdiğimi; kişisel verilerimin silinmesi/anonimleştirilmesi veya yok edilmesi için talepte bulunmadığım sürece yukarıda belirtilen veri işleme faaliyetlerine RB tarafından devam edileceğini;</p>
                    </div>
                </div>
            </div>
        </main>
    </div>
</template>

<script>
    import EventBus from "../main";

    export default {
        name: "Privacy",
        mounted() {
            EventBus.$emit('menu-status', false);
            this.$store.commit('navigationStatus', 'subPage');
        }
    }
</script>

<style lang="scss">


    $base-width: 1140px;
    $icon-font: "Font Awesome 5 Free";


    .white-wrapper {

        background-color: white;
        width: 100%;
    }

    .privacy {

        min-height: calc(100vh - 121px);
        color: black;

        &__wrapper {
            width: 666px;
            margin: 0 auto;
        }

        &__big-title {
            font-size: 25px;
            font-weight: bold;
            color: black;
            display: flex;
            justify-content: center;
            margin: 30px 0;
        }

        &__description {
            margin-bottom: 50px;
        }
    }


    @media only screen and (max-device-width: 768px) {
        
        .privacy__big-title {
            font-size: 5vw !important;
        }
        .privacy__description {
            font-size: 4vw;
        }
        .privacy {

            &__wrapper {
                width: 100%;
            }

            &__description {
                padding: 0 20px;
            }
        }
    }
</style>